export { default as HygieneSchema } from './hygiene-schema.jsx';
